module.exports = __webpack_public_path__ + "img/prophecies_mobile.39c3c15a.svg";